import React, { useState, useEffect } from "react";
import { OuterContainer } from "../../EventCreation/styles";
import ActionBar from "../../common/ActionBar";
import styled from "styled-components";
import theme from "../../../assets/theme";
import {
  Paper,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Formik } from "formik";
import FormField, { ButtonContainer, FormControl } from "../FormInputs";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import EventService from "../../../services/EventService";
import { navigate } from "@reach/router";
import _ from "lodash";

const Communicate = (id) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));

  const [items, setItems] = useState([]);
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [clickedButton, setClickedButton] = useState("");

  const initialState = {
    fullName: "",
    clientId: "",
    email: "",
    label: "",
  };

  const inputs = [
    { name: "fullName", label: "Full Name", type: "switch" },
    { name: "clientId", label: "DP Id/Client ID", type: "switch" },
    { name: "email", label: "Email Address", type: "switch" },
    {
      name: "label",
      label: "Label",
      type: "text",
      placeholder: "Enter label",
    },
  ];

  const custom_buttons = [
    {
      label: "SAVE",
      color: "default",
      primary: true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  const deleteCommentItems = (index, values, setFieldValue) => {
    const new_items = [...values?.items].filter((ci, idx) => idx !== index);
    setFieldValue("items", new_items);
  };

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "communicate");
        setItems(response);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        window.scrollTo(0, 0);
        setLoader({ state: false });
      }
    }
    if (id?.id) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id?.id, "communicate");
      setItems(response);
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description Email Template submit function
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        communicateFields: values?.items,
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        navigate(`/dashboard/eventmanager/polling/${id?.id}`);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "feedback":
        id?.id
          ? navigate(`/dashboard/eventmanager/feedback/${id?.id}`)
          : navigate(`/dashboard/eventmanager/feedback`);
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "Feedback",
                "Communicate",
                items?.eventName
                  ? `${items?.eventName} (${items?.eventDate})`
                  : "",
              ]
            : ["Event Manager", "Feedback", "Communicate"]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            items: items?.communicateFields?.length
              ? items?.communicateFields?.map((item) => ({
                  ...item,
                  fullName: item?.fullName,
                  clientId: item?.clientId,
                  email: item?.email,
                  label: item?.label,
                }))
              : [initialState] || [initialState],
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
          validationSchema={""}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
            handleSubmit,
            resetForm,
          }) => (
            <FormContainer>
              <Container>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Communicate</Heading>
                  {values.items.map((arr, index) => (
                    <Paper
                      elevation={3}
                      style={{
                        padding: 16,
                        border: "1px solid #e1e3ee",
                        marginTop: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={3}
                        style={{ padding: 16 }}
                      >
                        {inputs.map((item, idx) => (
                          <Grid
                            item
                            xs={isBigScreen ? 4 : 12}
                            key={`items[${index}].${item.name}`}
                            style={styles.gridItem}
                          >
                            <FormField
                              {...{
                                item,
                                handleChange,
                                values,
                                errors,
                              }}
                              value={arr[item.name]}
                              name={`items[${index}].${item.name}`}
                              touched={`items[${index}].${item.name}`}
                              direction={"row"}
                            />
                          </Grid>
                        ))}
                      </Grid>
                      {values.items.length > 1 && (
                        <Grid
                          item
                          xs={12}
                          style={{
                            textAlign: "left",
                            marginTop: "20px",
                          }}
                        >
                          <PrimaryCTAButton
                            style={{ width: "auto", marginLeft: 8 }}
                            onClick={() =>
                              deleteCommentItems(index, values, setFieldValue)
                            }
                          >
                            Delete
                          </PrimaryCTAButton>
                        </Grid>
                      )}
                    </Paper>
                  ))}
                  {/* <ButtonWrapper>
                    <SecondaryCTAButton
                      onClick={() => addCommentItems(values, setFieldValue)}
                      style={{ paddingLeft: 0 }}
                    >
                      <AddCircleOutline
                        style={{ marginRight: "10px", marginLeft: "5px" }}
                      />{" "}
                      Add More Fields
                    </SecondaryCTAButton>
                  </ButtonWrapper> */}
                  <FormControl>
                    <ButtonContainer>
                      {custom_buttons.map((button) => (
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            handleButtonClick(button, resetForm, handleSubmit)
                          }
                        >
                          {button.label}
                        </PrimaryCTAButton>
                      ))}
                    </ButtonContainer>
                  </FormControl>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default Communicate;

const Container = styled.div`
  padding: 20px 15px;
  min-height:100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 7px;
  }
`;

export const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 125px;
`;
